<div class="person-details">
  <img
    class="person-image"
    [appAuthSrc]="imageUrl()"
    [appAuthSrcFallback]="imageUrlFallback()"
    [defaultImage]="defaultImage()"
    alt="User photo"
  >
  <div class="flex-col gap-8 w-100">
    <label for="name">{{ 'PERSONS.PERSON_NAME' | translate }}</label>
    <input
      [formControl]="nameForm"
      id="name"
      type="text"
      [placeholder]="'PERSONS.PERSON_NAME' | translate"
      class="ui-input ui-input-40"
      (blur)="onTouch?.()"
    >
  </div>
</div>
